// library
import { ArSymbol } from '@aceroll/core/library';

// services
import { soundService, gsap, ArBitmapText, Counter } from '@aceroll/core';

export class Expand extends ArSymbol {
	#expandTl = gsap.timeline();

	opened = false;
	counter = null;
	value = null;

	constructor() {
		super(...arguments);
		this.#createCounter();
	}

	#createCounter() {
		const value = ArBitmapText.from('bitmap-hearts', '9999', 'Wild Multiplier');

		value.anchor.set(0.5);
		value.style.fontSize = 84;
		value.style.letterSpacing = -40;
		value.position.set(70, 780);
		value.visible = false;

		this.value = value;
		this.addChild(value);

		this.counter = new Counter({
			callback: (v) => {
				value.text = 'x' + (~~v || 1);
			}
		});
	}

	async land() {
		super.land();

		const { sounds } = this.config.default;
		if (sounds.land) {
			soundService.play(sounds.land);
		}
	}

	async frame() {
		return Promise.resolve();
	}

	async dimmIn() {
		return;
	}

	async dimmOut() {
		return;
	}

	reset() {
		super.reset();
		this.value.visible = false;
		this.opened = false;
		this.#expandTl.clear();
	}

	static() {
		if (this.opened) {
			return;
		}
		super.static();
	}

	async expand(multiplier) {
		this.image.visible = false;
		this.spine.visible = true;
		this.opened = true;

		const { sounds } = this.config.default;

		if (sounds.expand) {
			soundService.play(sounds.expand);
		}

		// move symbol to the first row
		this.#expandTl.to(this.position, {
			y: 81,
			duration: 0.001 * 900,
			ease: 'power2.inOut'
		});
		await this.animate('expand').then(() => {
			this.value.visible = true;
			this.counter.reset();
			this.counter.playFromTo(0, multiplier, 300);
		});
	}

	async stick(count) {
		this.image.visible = false;
		this.spine.visible = true;

		const { animations } = this.config.default.spine;
		const { sounds } = this.config.default;

		this.spine.setSkin(this.skins[`number_${count}`]);


		if (sounds.open) {
			soundService.play(sounds.open);
		}

		await this.spine.setImmediately(animations.open);

		this.spine.addImmediately(animations.idle, true);
	}
}
